// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"88":"login-page","316":"register-page","811":"training-page","913":"library-page"}[chunkId] || chunkId) + "." + {"88":"6045bf84","316":"8c1f1864","811":"2f2887e0","913":"c5977925","954":"d18e11d6"}[chunkId] + ".chunk.css";
};